(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[343,111,545,464,357,167,486,400,247],{

/***/ 7280:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 702:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/b/[slug]",
      function () {
        return __webpack_require__(5452);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FV": function() { return /* binding */ fetchBusinessProfile; },
  "jB": function() { return /* binding */ useBusinessProfile; },
  "yL": function() { return /* binding */ useProvider; },
  "DF": function() { return /* binding */ useReviews; },
  "Su": function() { return /* binding */ useServices; }
});

// UNUSED EXPORTS: fetchAllServices, fetchProviders, fetchReviews

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(6200);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(5347);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 39 modules
var lib_axios = __webpack_require__(5960);
;// CONCATENATED MODULE: ./lib/axios.ts

const ENDPOINT_URL = "https://planet.yocale.com";
const axios_axios = lib_axios/* default.create */.Z.create({
    baseURL: "".concat(ENDPOINT_URL, "/api/v1")
});

// EXTERNAL MODULE: ./queries/index.query.ts + 1 modules
var index_query = __webpack_require__(5866);
;// CONCATENATED MODULE: ./hooks/useFetch.ts



const PAGINATE_LIMIT = Number("10");
const fetchReviews = async function(slug) {
    let pageParam = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    const _pageParam = pageParam !== null && pageParam || 0;
    const res = await axios_axios.get("/businesses/".concat(slug, "/reviews?offset=").concat(_pageParam, "&limit=").concat(limit));
    return res.data.data;
};
const fetchServices = async function(slug) {
    let pageParam = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    const _pageParam = pageParam !== null && pageParam || 0;
    const res = await axios_axios.get("/businesses/".concat(slug, "/services?offset=").concat(_pageParam, "&limit=").concat(limit));
    return res.data.data;
};
const fetchProviders = async function(slug) {
    let pageParam = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    const _pageParam = pageParam !== null && pageParam || 0;
    const res = await axios_axios.get("/businesses/".concat(slug, "/providers?offset=").concat(_pageParam, "&limit=").concat(limit));
    return res.data.data;
};
const fetchAllServices = async function(slug) {
    let pageParam = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        offset: 0,
        limit: 0,
        hasNext: true,
        items: []
    }, limit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 50;
    const offset = pageParam * limit;
    return axios.get("/businesses/".concat(slug, "/services?offset=").concat(offset, "&limit=").concat(limit)).then((res)=>{
        console.log("Fetch All Services, Offset: ".concat(offset, " - Limit: ").concat(limit));
        data.items.push(...res.data.data.items);
        data.offset = res.data.data.offset;
        data.limit = res.data.data.limit;
        data.hasNext = res.data.data.hasNext;
        if (!res.data.data.hasNext) return data;
        return fetchAllServices(slug, pageParam + 1, data);
    });
};
const fetchBusinessProfile = async function(slug) {
    let fields = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "services,providers,reviews,locations";
    const req = await axios_axios("/businesses/".concat(slug, "?fields=").concat(fields));
    return req.data;
};
const useBusinessProfile = ()=>{
    return (0,useQuery/* useQuery */.a)([
        index_query/* queries.publicProfile.businessKey */.o.publicProfile.businessKey
    ], {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchIntervalInBackground: false
    });
};
const useReviews = (slug)=>{
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)([
        "reviews"
    ], async (param)=>{
        let { pageParam =0  } = param;
        return fetchReviews(slug, pageParam, PAGINATE_LIMIT);
    }, {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchIntervalInBackground: false,
        getNextPageParam: (lastPage, pages)=>{
            if (lastPage.hasNext) {
                return pages.length * PAGINATE_LIMIT;
            } else {
                return undefined;
            }
        }
    });
};
const useServices = (slug)=>{
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)([
        "services"
    ], async (param)=>{
        let { pageParam =0  } = param;
        return fetchServices(slug, pageParam, PAGINATE_LIMIT);
    }, {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchIntervalInBackground: false,
        getNextPageParam: (lastPage, pages)=>{
            if (lastPage.hasNext) {
                return pages.length * PAGINATE_LIMIT;
            } else {
                return undefined;
            }
        }
    });
};
const useProvider = (slug)=>{
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)([
        "providers"
    ], async (param)=>{
        let { pageParam =0  } = param;
        return fetchProviders(slug, pageParam, PAGINATE_LIMIT);
    }, {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchIntervalInBackground: false,
        getNextPageParam: (lastPage, pages)=>{
            if (lastPage.hasNext) {
                return (pages.length - 1) * PAGINATE_LIMIT + PAGINATE_LIMIT;
            } else {
                return undefined;
            }
        }
    });
};



/***/ }),

/***/ 3890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useHowManyItems; },
/* harmony export */   "f": function() { return /* binding */ useCanRender; }
/* harmony export */ });
/* harmony import */ var _useFetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9350);
/* harmony import */ var types_business_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3345);


const useCanRender = (section)=>{
    const { data: businessProfile  } = (0,_useFetch__WEBPACK_IMPORTED_MODULE_0__/* .useBusinessProfile */ .jB)();
    const widgetSetting = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data.widget;
    const renderMethod = widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.settings[section].renderMethod;
    return renderMethod !== types_business_types__WEBPACK_IMPORTED_MODULE_1__/* .RenderMethod.NoRender */ .zT.NoRender;
};
const useHowManyItems = (section)=>{
    const { data: businessProfile  } = (0,_useFetch__WEBPACK_IMPORTED_MODULE_0__/* .useBusinessProfile */ .jB)();
    const sectionJSON = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data[section];
    const lengthOfItems = (sectionJSON === null || sectionJSON === void 0 ? void 0 : sectionJSON.items.length) || 0;
    return lengthOfItems;
};


/***/ }),

/***/ 5452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(4078);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(3906);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/I18nProvider.js
var I18nProvider = __webpack_require__(459);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(8757);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(7280);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./hooks/useRender.ts
var useRender = __webpack_require__(3890);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(6200);
// EXTERNAL MODULE: ./hooks/useFetch.ts + 1 modules
var useFetch = __webpack_require__(9350);
// EXTERNAL MODULE: ./queries/index.query.ts + 1 modules
var index_query = __webpack_require__(5866);
;// CONCATENATED MODULE: ./hooks/useStickyNavbars.ts

function useStickyNavbars(headerRef, tabRef) {
    const $header = headerRef.current;
    const $tab = tabRef.current;
    (0,react.useEffect)(()=>{
        if ($tab && $header) {
            const headerHeight = $header.clientHeight;
            $tab.style.top = "".concat(headerHeight, "px");
        }
    }, [
        $header,
        $tab
    ]);
}
/* harmony default export */ var hooks_useStickyNavbars = (useStickyNavbars);

// EXTERNAL MODULE: ./locales/en/common.json
var en_common = __webpack_require__(464);
// EXTERNAL MODULE: ./locales/fr/common.json
var fr_common = __webpack_require__(5167);
// EXTERNAL MODULE: ./locales/ar/common.json
var ar_common = __webpack_require__(1111);
// EXTERNAL MODULE: ./locales/de/common.json
var de_common = __webpack_require__(1545);
// EXTERNAL MODULE: ./locales/es/common.json
var es_common = __webpack_require__(357);
// EXTERNAL MODULE: ./locales/it/common.json
var it_common = __webpack_require__(9486);
// EXTERNAL MODULE: ./locales/pt/common.json
var pt_common = __webpack_require__(5864);
// EXTERNAL MODULE: ./locales/ru/common.json
var ru_common = __webpack_require__(7247);
// EXTERNAL MODULE: ./types/business.types.ts
var business_types = __webpack_require__(3345);
;// CONCATENATED MODULE: ./components/Breadcrumbs/Breadcrumbs.tsx


function Breadcrumbs(param) {
    let { children , separator ="/"  } = param;
    const allItems = react.Children.toArray(children).filter(react.isValidElement);
    const itemsWithSeparators = allItems.flatMap((item, index, array)=>{
        const isLast = index === array.length - 1;
        return isLast ? [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "text-charcoalGray",
                children: item
            }, "item-".concat(index))
        ] : [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "text-muted",
                children: item
            }, "item-".concat(index)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                "aria-hidden": "true",
                className: "mx-2 select-none text-muted",
                children: separator
            }, "sep-".concat(index))
        ];
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: "mx-4 md:mx-0 mb-4 overflow-x-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
            className: "flex whitespace-nowrap items-center list-none p-0 m-0",
            children: itemsWithSeparators
        })
    });
}
/* harmony default export */ var Breadcrumbs_Breadcrumbs = (Breadcrumbs);

;// CONCATENATED MODULE: ./containers/Layout/BusinessProfileBreadcrumb.tsx




const OTHER_SUBCATEGORY_ID = 47;
function BusinessProfileBreadcrumb(param) {
    let { profile  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("common");
    // Scroll to top on mount
    (0,react.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    const breadcrumbItems = (0,react.useMemo)(()=>{
        var _profile_locations_items, _profile_locations_items_;
        if (!profile) return [];
        const location = (_profile_locations_items = profile.locations.items) === null || _profile_locations_items === void 0 ? void 0 : (_profile_locations_items_ = _profile_locations_items[0]) === null || _profile_locations_items_ === void 0 ? void 0 : _profile_locations_items_.address;
        const subcategory = profile.industry.businessSubcategories.filter((item)=>item.id !== OTHER_SUBCATEGORY_ID)[0];
        const home = {
            label: "Home",
            href: "".concat("https://www.yocale.com", "/l")
        };
        const subCategory = {
            label: subcategory.listingName,
            href: "".concat(home.href, "/").concat(subcategory.listingSlugName)
        };
        const city = (location === null || location === void 0 ? void 0 : location.city) ? {
            label: "".concat(location.country, " - ").concat(location.city),
            href: "".concat(subCategory.href, "/").concat(location.formattedCountry, "-").concat(location.formattedCity)
        } : undefined;
        const neighborhood = (location === null || location === void 0 ? void 0 : location.neighborhood) && city ? {
            label: location.neighborhood,
            href: "".concat(city.href, "/").concat(location.formattedNeighborhood)
        } : undefined;
        const business = {
            label: profile.name
        };
        return [
            home,
            subCategory,
            city,
            neighborhood,
            business
        ].filter(Boolean);
    }, [
        profile
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-3",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_Breadcrumbs, {
            children: breadcrumbItems.map((item, index)=>{
                return item.href ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: item.href,
                    rel: "noopener noreferrer",
                    children: item.label
                }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: item.label
                }, index);
            })
        })
    });
}
/* harmony default export */ var Layout_BusinessProfileBreadcrumb = (/*#__PURE__*/(0,react.memo)(BusinessProfileBreadcrumb));

;// CONCATENATED MODULE: ./pages/b/[slug].tsx






















const languages = Object.values(business_types/* AvailableLanguages */.D);
const Layout = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(347), __webpack_require__.e(730), __webpack_require__.e(931)]).then(__webpack_require__.bind(__webpack_require__, 8931)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8931)
            ]
    },
    ssr: true
});
const NavigationTab = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(347), __webpack_require__.e(591)]).then(__webpack_require__.bind(__webpack_require__, 1591)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1591)
            ]
    },
    ssr: true
});
const Cover = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(228), __webpack_require__.e(347), __webpack_require__.e(832), __webpack_require__.e(169), __webpack_require__.e(448)]).then(__webpack_require__.bind(__webpack_require__, 9448)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9448)
            ]
    },
    ssr: true
});
const AboutContainer = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(347), __webpack_require__.e(259)]).then(__webpack_require__.bind(__webpack_require__, 7259)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(7259)
            ]
    },
    ssr: true
});
const ProviderContainer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 531).then(__webpack_require__.bind(__webpack_require__, 7531)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(7531)
            ]
    },
    ssr: true
});
const ServiceContainer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 821).then(__webpack_require__.bind(__webpack_require__, 4821)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(4821)
            ]
    },
    ssr: true
});
const ReviewsContainer = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(228), __webpack_require__.e(142)]).then(__webpack_require__.bind(__webpack_require__, 1885)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1885)
            ]
    },
    ssr: true
});
const Footer = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(347), __webpack_require__.e(832), __webpack_require__.e(279)]).then(__webpack_require__.bind(__webpack_require__, 9279)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9279)
            ]
    },
    ssr: false,
    loading: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Loading..."
        })
});
function BusinessProfile(param) {
    let { slug  } = param;
    const { locale  } = (0,router.useRouter)();
    const { lang  } = (0,useTranslation/* default */.Z)();
    const { data: businessProfile  } = (0,useQuery/* useQuery */.a)([
        index_query/* queries.publicProfile.businessKey */.o.publicProfile.businessKey
    ], ()=>(0,useFetch/* fetchBusinessProfile */.FV)(slug), {
        refetchOnMount: false,
        refetchOnWindowFocus: false
    });
    const profile = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data;
    const headerRef = (0,react.useRef)();
    const tabRef = (0,react.useRef)();
    const onHeaderRefChange = (ref)=>{
        headerRef.current = ref;
    };
    hooks_useStickyNavbars(headerRef, tabRef);
    const [path, setPath] = (0,react.useState)("about");
    const isProviderRenderable = (0,useRender/* useCanRender */.f)("provider");
    const isReviewRenderable = (0,useRender/* useCanRender */.f)("review");
    const language = locale === "default" ? "en" : lang;
    const translationKeyValues = (0,react.useMemo)(()=>{
        let common;
        switch(language){
            case business_types/* AvailableLanguages.EN */.D.EN:
                common = en_common;
                break;
            case business_types/* AvailableLanguages.FR */.D.FR:
                common = fr_common;
                break;
            case business_types/* AvailableLanguages.DE */.D.DE:
                common = de_common;
                break;
            case business_types/* AvailableLanguages.IT */.D.IT:
                common = it_common;
                break;
            case business_types/* AvailableLanguages.ES */.D.ES:
                common = es_common;
                break;
            case business_types/* AvailableLanguages.PT */.D.PT:
                common = pt_common;
                break;
            case business_types/* AvailableLanguages.RU */.D.RU:
                common = ru_common;
                break;
            case business_types/* AvailableLanguages.AR */.D.AR:
                common = ar_common;
                break;
            default:
                common = en_common;
                break;
        }
        return common;
    }, [
        language
    ]);
    (0,react.useEffect)(()=>{
        if (locale === "default") {
            document.documentElement.lang = language;
        }
    }, [
        language,
        locale
    ]);
    if (profile) {
        var _profile_industry, _profile_industry_businessSubcategories, _widget_settings_appearance, _profile_logo;
        const widget = profile === null || profile === void 0 ? void 0 : profile.widget;
        const hideBreadcrumb = !((_profile_industry = profile.industry) === null || _profile_industry === void 0 ? void 0 : (_profile_industry_businessSubcategories = _profile_industry.businessSubcategories) === null || _profile_industry_businessSubcategories === void 0 ? void 0 : _profile_industry_businessSubcategories.length) || profile.industry.businessSubcategories.length === 1 && profile.industry.businessSubcategories[0].id === OTHER_SUBCATEGORY_ID || !(profile === null || profile === void 0 ? void 0 : profile.isFreemium);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(I18nProvider/* default */.Z, {
            lang: language,
            namespaces: {
                common: translationKeyValues
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
                businessKey: profile.key,
                title: profile.name,
                description: profile.description,
                primaryColor: (_widget_settings_appearance = widget.settings.appearance) === null || _widget_settings_appearance === void 0 ? void 0 : _widget_settings_appearance.secondaryColor,
                logoURL: (_profile_logo = profile.logo) === null || _profile_logo === void 0 ? void 0 : _profile_logo.url,
                headerProps: {
                    onHeaderRefChange
                },
                languages: languages,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container mx-auto max-w-screen-xl md:px-10",
                    children: [
                        !hideBreadcrumb && /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_BusinessProfileBreadcrumb, {
                            profile: profile
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cover, {
                            businessName: profile.name,
                            businessLogo: profile.logo,
                            rate: profile.rate,
                            covers: profile.coverImages
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: tabRef,
                            id: "tab",
                            className: "sticky top-16 pt-4 mb-8 bg-white/80 backdrop-blur-md z-20",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationTab, {
                                path: path,
                                setPath: setPath
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "px-4 md:px-0 pb-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    id: "about",
                                    className: classnames_default()("section", {
                                        hidden: path !== "about"
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContainer, {
                                            profile: profile
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                                    ]
                                }),
                                isProviderRenderable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "providers",
                                    className: classnames_default()("section", {
                                        hidden: path !== "providers"
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderContainer, {
                                        providersCount: profile.providers.items.length
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "services",
                                    className: classnames_default()("section", {
                                        hidden: path !== "services"
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceContainer, {
                                        services: profile.services
                                    })
                                }),
                                isReviewRenderable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "reviews",
                                    className: classnames_default()("section", {
                                        hidden: path !== "reviews"
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsContainer, {
                                        reviews: profile.reviews
                                    })
                                })
                            ]
                        }),
                         false && /*#__PURE__*/ 0
                    ]
                })
            })
        });
    }
}
var __N_SSG = true;
/* harmony default export */ var _slug_ = (BusinessProfile);


/***/ }),

/***/ 5866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ queries; }
});

// EXTERNAL MODULE: ./node_modules/@lukemorales/query-key-factory/dist/index.mjs
var dist = __webpack_require__(4967);
;// CONCATENATED MODULE: ./queries/businessProfile.query.ts

const businessProfileKeys = (0,dist/* createQueryKeys */.no)("publicProfile", {
    businessKey: null
});

;// CONCATENATED MODULE: ./queries/index.query.ts


const queries = (0,dist/* mergeQueryKeys */.kR)(businessProfileKeys);


/***/ }),

/***/ 3345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ AvailableLanguages; },
/* harmony export */   "Vn": function() { return /* binding */ AppointmentType; },
/* harmony export */   "eb": function() { return /* binding */ defaultServiceSorting; },
/* harmony export */   "zT": function() { return /* binding */ RenderMethod; }
/* harmony export */ });
/* unused harmony exports ServiceUnavailable, ProviderUnavailable */
const Weekdays = (/* unused pure expression or super */ null && ([
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday"
]));
const Links = (/* unused pure expression or super */ null && ([
    "website",
    "facebook",
    "twitter",
    "instagram",
    "youtube"
]));
var AppointmentType;
(function(AppointmentType) {
    AppointmentType["InPerson"] = "in-person";
    AppointmentType["Virtual"] = "virtual";
})(AppointmentType || (AppointmentType = {}));
var RenderMethod;
(function(RenderMethod) {
    RenderMethod["Categorized"] = "categorized";
    RenderMethod["Plain"] = "plain";
    RenderMethod["NoRender"] = "no-render";
})(RenderMethod || (RenderMethod = {}));
var AvailableLanguages;
(function(AvailableLanguages) {
    AvailableLanguages["AR"] = "ar";
    AvailableLanguages["EN"] = "en";
    AvailableLanguages["FR"] = "fr";
    AvailableLanguages["ES"] = "es";
    AvailableLanguages["DE"] = "de";
    AvailableLanguages["IT"] = "it";
    AvailableLanguages["PT"] = "pt";
    AvailableLanguages["RU"] = "ru";
})(AvailableLanguages || (AvailableLanguages = {}));
// export enum ServiceUnavailable {
// 	Price = "price",
// 	Duration = "duration",
// 	Description = "description ",
// }
const ServiceUnavailable = (/* unused pure expression or super */ null && ([
    "description",
    "price",
    "duration",
    "image"
]));
var defaultServiceSorting;
(function(defaultServiceSorting) {
    defaultServiceSorting["DURATION"] = "DURATION";
    defaultServiceSorting["AVAILABILITY"] = "AVAILABILITY";
    defaultServiceSorting["ALPHABETICALLY"] = "ALPHABETICALLY";
    defaultServiceSorting["CUSTOM"] = "CUSTOM";
})(defaultServiceSorting || (defaultServiceSorting = {}));
// export enum ProviderUnavailable {
// 	"rate",
// }
const ProviderUnavailable = (/* unused pure expression or super */ null && ([
    "rate",
    "image"
]));


/***/ }),

/***/ 1111:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"emptystate":{"providers":"لا يوجد مقدمي خدمات متاحين","reviews":"لا توجد مراجعات متاحة","services":"لا توجد خدمات متاحة"},"global":{"appointments":"انتقل إلى المواعيد","book":"كتاب","booknow":"احجز الآن","noreview":"لا توجد مراجعات حتى الآن","showless":"إظهار أقل","showmore":"عرض المزيد","socials":"مواقع التواصل الاجتماعي"},"navigation":{"about":"عن","location":"موقع","provider":"مزود","review":"مراجعة","service":"خدمة"},"sections":{"about":{"description":"تتوفر إمكانية حجز المواعيد عبر الإنترنت لهذه الشركة من خلال Yocale. اختر مقدم الخدمة المفضل لديك أو الخدمات المطلوبة للحجز عبر الإنترنت."},"reviews":{"customerRating_few":"{{count}} تقييم العميل","customerRating_many":"{{count}} تقييم العميل","customerRating_one":"{{count}} تقييم العميل","customerRating_other":"{{count}} تقييم العملاء","customerRating_two":"{{count}} تقييم العميل","overall":"{{count}} من 5"},"services":{"accordion_label_few":"خدمة {{count}}","accordion_label_many":"خدمة {{count}}","accordion_label_one":"خدمة {{count}}","accordion_label_other":"خدمات {{count}}","accordion_label_two":"خدمة {{count}}","others":"آحرون","virtual":"افتراضي"}},"social":{"copy_clipboard":"نسخ إلى الحافظة","copy_clipboard_done":"تم نسخها إلى الحافظة","share_facebook":"شارك على الفيسبوك","share_tweet":"سقسقة","website":"موقع إلكتروني"},"workingHours":{"closed":"مغلق","title":"ساعات العمل","weekdays":{"friday":"جمعة","monday":"الاثنين","saturday":"السبت","sunday":"الأحد","thursday":"يوم الخميس","tuesday":"يوم الثلاثاء","wednesday":"الأربعاء"}}}');

/***/ }),

/***/ 1545:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"emptystate":{"providers":"Keine Anbieter verfügbar","reviews":"Keine Bewertungen vorhanden","services":"Keine Dienste verfügbar"},"global":{"appointments":"Zu den Terminen gehen","book":"Buchen Sie","booknow":"Jetzt buchen","noreview":"Noch keine Bewertungen","showless":"Weniger anzeigen","showmore":"Mehr anzeigen","socials":"Soziale Netzwerke"},"navigation":{"about":"Über","location":"Standort","provider":"Anbieter","review":"Überprüfung","service":"Dienst"},"sections":{"about":{"description":"Die Online-Terminvereinbarung für dieses Unternehmen ist über Yocale verfügbar. Wählen Sie Ihren bevorzugten Anbieter oder die gewünschten Dienstleistungen, um online zu buchen."},"reviews":{"customerRating_few":"{{count}} Kundenbewertung","customerRating_many":"{{count}} Kundenbewertung","customerRating_one":"{{count}} Kundenbewertung","customerRating_other":"{{count}} Kundenbewertung","customerRating_two":"{{count}} Kundenbewertung","overall":"{{count}} von 5"},"services":{"accordion_label_few":"{{count}} Dienst","accordion_label_many":"{{count}} Dienst","accordion_label_one":"{{count}} Dienst","accordion_label_other":"{{count}} Dienstleistungen","accordion_label_two":"{{count}} Dienst","others":"Andere","virtual":"Virtuell"}},"social":{"copy_clipboard":"In die Zwischenablage kopieren","copy_clipboard_done":"In die Zwischenablage kopiert","share_facebook":"Auf Facebook teilen","share_tweet":"Tweet","website":"Website"},"workingHours":{"closed":"Geschlossen","title":"Arbeitszeiten","weekdays":{"friday":"Freitag","monday":"Montag","saturday":"Samstag","sunday":"Sonntag","thursday":"Donnerstag","tuesday":"Dienstag","wednesday":"Mittwoch"}}}');

/***/ }),

/***/ 464:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"emptystate":{"providers":"No providers available","reviews":"No reviews available","services":"No services available"},"global":{"appointments":"Go to Appointments","book":"Book","booknow":"Book Now","noreview":"No reviews yet","showless":"Show Less","showmore":"Show More","socials":"Socials"},"navigation":{"about":"About","location":"Location","provider":"Provider","review":"Review","service":"Service"},"sections":{"about":{"description":"Online appointment scheduling for this business is available through Yocale. Choose your favorite provider or desired services to book online."},"reviews":{"customerRating_few":"{{count}} customer rating","customerRating_many":"{{count}} customer rating","customerRating_one":"{{count}} customer rating","customerRating_other":"{{count}} customers rating","customerRating_two":"{{count}} customer rating","overall":"{{count}} out of 5"},"services":{"accordion_label_few":"{{count}} Service","accordion_label_many":"{{count}} Service","accordion_label_one":"{{count}} Service","accordion_label_other":"{{count}} Services","accordion_label_two":"{{count}} Service","others":"Others","virtual":"Virtual"}},"social":{"copy_clipboard":"Copy to clipboard","copy_clipboard_done":"Copied to clipboard","share_facebook":"Share on facebook","share_tweet":"Tweet","website":"Website"},"workingHours":{"closed":"Closed","title":"Working Hours","weekdays":{"friday":"Friday","monday":"Monday","saturday":"Saturday","sunday":"Sunday","thursday":"Thursday","tuesday":"Tuesday","wednesday":"Wednesday"}}}');

/***/ }),

/***/ 357:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"emptystate":{"providers":"No hay proveedores disponibles","reviews":"No hay opiniones disponibles","services":"No hay servicios disponibles"},"global":{"appointments":"Ir a Citas","book":"Reserve","booknow":"Reserve ahora","noreview":"Aún no hay opiniones","showless":"Mostrar menos","showmore":"Ver más","socials":"Sociales"},"navigation":{"about":"Acerca de","location":"Ubicación","provider":"Proveedor","review":"Consulte","service":"Servicio"},"sections":{"about":{"description":"La programación de citas en línea para este negocio está disponible a través de Yocale. Elija su proveedor favorito o los servicios deseados para reservar en línea."},"reviews":{"customerRating_few":"{{count}} valoración del cliente","customerRating_many":"{{count}} valoración del cliente","customerRating_one":"{{count}} valoración del cliente","customerRating_other":"{{count}} valoración de los clientes","customerRating_two":"{{count}} valoración del cliente","overall":"{{count}} de 5"},"services":{"accordion_label_few":"{{count}} Servicio","accordion_label_many":"{{count}} Servicio","accordion_label_one":"{{count}} Servicio","accordion_label_other":"{{count}} Servicios","accordion_label_two":"{{count}} Servicio","others":"Otros","virtual":"Virtual"}},"social":{"copy_clipboard":"Copiar al portapapeles","copy_clipboard_done":"Copiado al portapapeles","share_facebook":"Compartir en facebook","share_tweet":"Tweet","website":"Página web"},"workingHours":{"closed":"Cerrado","title":"Horario laboral","weekdays":{"friday":"Viernes","monday":"Lunes","saturday":"Sábado","sunday":"Domingo","thursday":"Jueves","tuesday":"Martes","wednesday":"Miércoles"}}}');

/***/ }),

/***/ 5167:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"emptystate":{"providers":"Aucun fournisseur disponible","reviews":"Pas de commentaires disponibles","services":"Aucun service disponible"},"global":{"appointments":"Aller à Rendez-vous","book":"Livre","booknow":"Réserver","noreview":"Pas encore de commentaires","showless":"Montrer moins","showmore":"Afficher plus","socials":"Socials"},"navigation":{"about":"A propos de","location":"Localisation","provider":"Fournisseur","review":"Révision","service":"Service"},"sections":{"about":{"description":"La prise de rendez-vous en ligne pour cette entreprise est disponible par l\'intermédiaire de Yocale. Choisissez votre fournisseur préféré ou les services souhaités pour réserver en ligne."},"reviews":{"customerRating_few":"{{count}} évaluation des clients","customerRating_many":"{{count}} évaluation des clients","customerRating_one":"{{count}} évaluation des clients","customerRating_other":"Note des clients de {{count}}","customerRating_two":"{{count}} évaluation des clients","overall":"{{count}} sur 5"},"services":{"accordion_label_few":"{{count}} Service","accordion_label_many":"{{count}} Service","accordion_label_one":"{{count}} Service","accordion_label_other":"{{count}} Services","accordion_label_two":"{{count}} Service","others":"Autres","virtual":"Virtuel"}},"social":{"copy_clipboard":"Copier dans le presse-papiers","copy_clipboard_done":"Copié dans le presse-papiers","share_facebook":"Partager sur facebook","share_tweet":"Tweet","website":"Site web"},"workingHours":{"closed":"Fermé","title":"Heures de travail","weekdays":{"friday":"Vendredi","monday":"Lundi","saturday":"Samedi","sunday":"Dimanche","thursday":"Jeudi","tuesday":"Mardi","wednesday":"Mercredi"}}}');

/***/ }),

/***/ 9486:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"emptystate":{"providers":"Nessun fornitore disponibile","reviews":"Nessuna recensione disponibile","services":"Nessun servizio disponibile"},"global":{"appointments":"Vai agli appuntamenti","book":"Libro","booknow":"Prenota ora","noreview":"Ancora nessuna recensione","showless":"Mostra meno","showmore":"Mostra di più","socials":"I social"},"navigation":{"about":"Circa","location":"Posizione","provider":"Fornitore","review":"Recensione","service":"Servizio"},"sections":{"about":{"description":"La programmazione online degli appuntamenti per questa attività è disponibile tramite Yocale. Scegliete il vostro fornitore preferito o i servizi desiderati per prenotare online."},"reviews":{"customerRating_few":"Valutazione del cliente {{count}}","customerRating_many":"Valutazione del cliente {{count}}","customerRating_one":"Valutazione del cliente {{count}}","customerRating_other":"Valutazione dei clienti di {{count}}","customerRating_two":"Valutazione del cliente {{count}}","overall":"{{count}} su 5"},"services":{"accordion_label_few":"{{count}} Servizio","accordion_label_many":"{{count}} Servizio","accordion_label_one":"{{count}} Servizio","accordion_label_other":"{{count}} Servizi","accordion_label_two":"{{count}} Servizio","others":"Altri","virtual":"Virtuale"}},"social":{"copy_clipboard":"Copia negli appunti","copy_clipboard_done":"Copiato negli appunti","share_facebook":"Condividi su facebook","share_tweet":"Tweet","website":"Sito web"},"workingHours":{"closed":"Chiuso","title":"Orario di lavoro","weekdays":{"friday":"Venerdì","monday":"Lunedì","saturday":"Sabato","sunday":"Domenica","thursday":"Giovedì","tuesday":"Martedì","wednesday":"Mercoledì"}}}');

/***/ }),

/***/ 5864:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"emptystate":{"providers":"Não há fornecedores disponíveis","reviews":"Não há comentários disponíveis","services":"Nenhum serviço disponível"},"global":{"appointments":"Ir para Marcações","book":"Livro","booknow":"Reservar agora","noreview":"Ainda não há comentários","showless":"Mostrar menos","showmore":"Mostrar mais","socials":"Socials"},"navigation":{"about":"Sobre","location":"Localização","provider":"Fornecedor","review":"Revisão","service":"Serviço"},"sections":{"about":{"description":"A marcação de consultas online para esta empresa está disponível através do Yocale. Escolha o seu fornecedor favorito ou os serviços pretendidos para efetuar a marcação online."},"reviews":{"customerRating_few":"{{count}} classificação do cliente","customerRating_many":"{{count}} classificação do cliente","customerRating_one":"{{count}} classificação do cliente","customerRating_other":"Avaliação dos clientes {{count}}","customerRating_two":"{{count}} classificação do cliente","overall":"{{count}} em 5"},"services":{"accordion_label_few":"{{count}} Serviço","accordion_label_many":"{{count}} Serviço","accordion_label_one":"{{count}} Serviço","accordion_label_other":"{{count}} Serviços","accordion_label_two":"{{count}} Serviço","others":"Outros","virtual":"Virtual"}},"social":{"copy_clipboard":"Copiar para a área de transferência","copy_clipboard_done":"Copiado para a área de transferência","share_facebook":"Partilhar no facebook","share_tweet":"Tweet","website":"Sítio Web"},"workingHours":{"closed":"Fechado","title":"Horário de trabalho","weekdays":{"friday":"Sexta-feira","monday":"Segunda-feira","saturday":"Sábado","sunday":"Domingo","thursday":"Quinta-feira","tuesday":"Terça-feira","wednesday":"Quarta-feira"}}}');

/***/ }),

/***/ 7247:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"emptystate":{"providers":"Провайдеры отсутствуют","reviews":"Отзывы отсутствуют","services":"Услуги не предоставляются"},"global":{"appointments":"Перейти к назначению","book":"Книга","booknow":"Забронировать сейчас","noreview":"Отзывов пока нет","showless":"Показать меньше","showmore":"Показать еще","socials":"Социальные сети"},"navigation":{"about":"О сайте","location":"Расположение","provider":"Поставщик","review":"Обзор","service":"Сервис"},"sections":{"about":{"description":"Онлайн-запись на прием к этому предприятию доступна через Yocale. Выберите своего любимого поставщика или желаемые услуги, чтобы записаться на прием онлайн."},"reviews":{"customerRating_few":"{{count}} рейтинг покупателей","customerRating_many":"{{count}} рейтинг покупателей","customerRating_one":"{{count}} рейтинг покупателей","customerRating_other":"Рейтинг покупателей {{count}}","customerRating_two":"{{count}} рейтинг покупателей","overall":"{{count}} из 5"},"services":{"accordion_label_few":"{{count}} Сервис","accordion_label_many":"{{count}} Сервис","accordion_label_one":"{{count}} Сервис","accordion_label_other":"{{count}} Услуги","accordion_label_two":"{{count}} Сервис","others":"Другие","virtual":"Виртуальный"}},"social":{"copy_clipboard":"Копировать в буфер обмена","copy_clipboard_done":"Скопировано в буфер обмена","share_facebook":"Поделиться на facebook","share_tweet":"Tweet","website":"Сайт"},"workingHours":{"closed":"Закрытый","title":"Рабочие часы","weekdays":{"friday":"Пятница","monday":"Понедельник","saturday":"Суббота","sunday":"Воскресенье","thursday":"Четверг","tuesday":"Вторник","wednesday":"Среда"}}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [564,774,888,179], function() { return __webpack_exec__(702); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);